export const ORG_SELECT_COLUMN_KEYS = {
  EXTERNAL_ID: "externalId",
  NAME: "name",
  PRODUCTS: "products",
  CREATED_AT: "createdAt",
} as const;

export const ORG_SELECT_COLUMN_DISPLAY_ITEMS = [
  { key: ORG_SELECT_COLUMN_KEYS.EXTERNAL_ID, label: "組織ID", isAlwaysShowing: true },
  { key: ORG_SELECT_COLUMN_KEYS.NAME, label: "組織名", isAlwaysShowing: true },
  { key: ORG_SELECT_COLUMN_KEYS.PRODUCTS, label: "契約サービス" },
  { key: ORG_SELECT_COLUMN_KEYS.CREATED_AT, label: "登録日" },
];

export const ORG_SELECT_DEFAULT_VISIBLE_COLUMNS: Record<string, boolean> = Object.fromEntries(
  ORG_SELECT_COLUMN_DISPLAY_ITEMS.map((item) => [item.key, true]),
);

export const ORG_SELECT_DEFAULT_COLUMN_ORDER = ORG_SELECT_COLUMN_DISPLAY_ITEMS.map((item) => item.key);

/** Fixed leading column that must always stay first and visible. */
export const ORG_SELECT_FIXED_COLUMN_ID = "select";
